module.exports = __webpack_public_path__ + "static/media/food2.03697b34.jpg";